<template>
    <div class="user-join-class-form">
        <div class="join-class-body">
            <b-form data-vv-scope="user-join-class-form">
                <b-row class="kelas">
                    <b-col sm="3">
                        <label for="input-code-kelas">Kode Kelas</label>
                    </b-col>
                    <b-col sm="9">
                        <b-form-input
                        id="input-code-kelas"
                        name="class_code"
                        data-vv-as="Kode kelas"
                        v-model="join_class_form.class_code"
                        type="text"
                        placeholder="Kode Kelas"
                        v-validate="'required'"
                        autocomplete="off"
                        ></b-form-input>
                        <span :class="{ 'error-validation': errors.first('user-join-class-form.class_code') }">{{ errors.first('user-join-class-form.class_code') }}</span>
                    </b-col>
                    <b-col sm="3">
                        <label for="input-code-kelas">Tahun Ajaran</label>
                    </b-col>
                    <b-col sm="9">
                        <b-form-select
                            v-model="join_class_form.tahun_ajaran_id"
                            name="tahun_ajaran_id"
                            v-validate="'required'"
                            value-field="id"
                            placeholder="Tahun Ajaran"
                            text-field="name"
                            data-vv-as="Tahun Ajaran"
                            :options="taList"
                        >
                            <b-form-select-option :value="null" disabled>Pilih Tahun Ajaran</b-form-select-option>
                        </b-form-select>
                        <span :class="{ 'error-validation': errors.first('user-join-class-form.tahun_ajaran_id') }">{{ errors.first('user-join-class-form.tahun_ajaran_id') }}</span>
                    </b-col>
                </b-row>
            </b-form>
        </div>
        <hr>
        <div class="join-class-footer d-flex justify-content-end">
            <b-button variant="outline-danger" size="md" style="width: 25%;" @click="hideJoinClassModal">BATAL</b-button>
            <b-button variant="primary" size="md" style="width: 25%;" @click.prevent="saveJoinClass">SIMPAN</b-button>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { EventBus } from '@/eventBus.js'
    export default {
        props: {
            id: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                join_class_form: {
                    class_code: null,
                    tahun_ajaran_id: null,
                    user_id: this.id
                }
            }
        },
        computed: {
            ...mapGetters({
                taList: 'getTaList'
            })
        },
        methods: {
            resetJoinClassForm() {
                this.join_class_form.class_code = null
                this.join_class_form.tahun_ajaran_id = null
                this.$validator.reset()
            },
            hideJoinClassModal() {
                EventBus.$emit('hideJoinClassModal', true)
            },
            async saveJoinClass() {
                let scope = 'user-join-class-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        let form = this.join_class_form 
						this.$store.dispatch('joinClass', form)
							.then((res) => {
                                this.$store.dispatch('getOverview')
                                this.$store.dispatch('getClassList')
                                this.hideJoinClassModal()
                                this.$swal.fire('Success', res.message, 'success')
							})
							.catch((err)=> {
                                let error = err.response
                                if (error.status == 400) {
                                    this.errorValidate(error.data, scope)
                                }
                                this.$swal.fire('Failed', err.response.data.message, 'error')
							})
                    }
                });
            },
            async getTaList() {
                this.isBusy = true
				await this.$store.dispatch('getTaList')
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			}
        },
		created () {
            this.getTaList();
			EventBus.$on('resetJoinClassForm', (val) => {
				if (val) {
					this.resetJoinClassForm()
				}
			})
        }
    }
</script>